var map = {
	"./AboutMtn/FinancialReports.vue": [
		"2e3c",
		"chunk-25bf21c6"
	],
	"./AboutMtn/InvestorRelations.vue": [
		"45f3",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-19e59977"
	],
	"./AboutMtn/PressReleases.vue": [
		"d2da",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-54f7f3e8",
		"chunk-1d55a23f"
	],
	"./AboutMtn/SocialResponsibility.vue": [
		"2c5d",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-7100ccdf"
	],
	"./AboutMtn/WhoWeAre.vue": [
		"cb60",
		"chunk-d0167b6e",
		"chunk-5ac386e0"
	],
	"./AboutMtn/index.vue": [
		"49c0",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-d0167b6e",
		"chunk-f64440b0"
	],
	"./AppDetails/index.vue": [
		"09d7",
		"chunk-24315eb0"
	],
	"./BundleDetails/index.vue": [
		"29a9",
		"chunk-0d5fe896"
	],
	"./Bundles/index.vue": [
		"8498",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-61498729"
	],
	"./Business/index.vue": [
		"3f5d",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-f4ddb492",
		"chunk-59d0fa1e"
	],
	"./CommercialApp/index.vue": [
		"fec9",
		"chunk-54f7f3e8",
		"chunk-5ac386e0"
	],
	"./Home/index.vue": [
		"16c0",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-f4ddb492",
		"chunk-488e3f5e"
	],
	"./InternationalRoamingCountries/index.vue": [
		"d7c9",
		"chunk-dd32c80c"
	],
	"./Intro/index.vue": [
		"27e0",
		"chunk-5faa7b7d",
		"chunk-f4ddb492"
	],
	"./MtnApps/index.vue": [
		"cc6d",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-4259973d"
	],
	"./MtnWorld/index.vue": [
		"3b67",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-f4ddb492",
		"chunk-1bc8e1c8"
	],
	"./Navbar/index.vue": [
		"a656"
	],
	"./NotFound.vue": [
		"9703"
	],
	"./OfferDetails/index.vue": [
		"e7da",
		"chunk-407219f5"
	],
	"./Offers/index.vue": [
		"d7d8",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-4dd5280b"
	],
	"./Payment/index.vue": [
		"2bbb",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-f4ddb492",
		"chunk-c7ba7ab0"
	],
	"./Personal/Home.vue": [
		"8a9e",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-f4ddb492",
		"chunk-586e78d3"
	],
	"./Personal/index.vue": [
		"20a6",
		"chunk-3fa38f75"
	],
	"./PopularBundles/index.vue": [
		"662c",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-ff436ed6"
	],
	"./PressReleasesCards/index.vue": [
		"cfc7",
		"chunk-5faa7b7d",
		"chunk-d1bd92d8"
	],
	"./Products/CallManagement.vue": [
		"e27f",
		"chunk-29f0c38b"
	],
	"./Products/CallManagementContent.vue": [
		"d4c7",
		"chunk-26de4657"
	],
	"./Products/InternationalCallsChanges.vue": [
		"55ed",
		"chunk-73a1f34c",
		"chunk-5ac386e0"
	],
	"./Products/MtnLines.vue": [
		"2182",
		"chunk-4129dab3",
		"chunk-e7fa9d30"
	],
	"./Products/PaymentAndRefill.vue": [
		"f5d6",
		"chunk-679ed44a",
		"chunk-5ac386e0"
	],
	"./Products/PaymentAndRefillContent.vue": [
		"57e8",
		"chunk-c192deba"
	],
	"./Products/PostPaid.vue": [
		"e586",
		"chunk-139942f5"
	],
	"./Products/PrePaid.vue": [
		"b938",
		"chunk-8560158a"
	],
	"./Products/SegmentProducts.vue": [
		"5ca5",
		"chunk-5faa7b7d",
		"chunk-72f417c5"
	],
	"./Products/index.vue": [
		"4bcf",
		"chunk-5faa7b7d",
		"chunk-73a1f34c",
		"chunk-679ed44a",
		"chunk-4129dab3",
		"chunk-7563eba6"
	],
	"./Profile/components/ActiveBundles.vue": [
		"8a56",
		"chunk-b973a296",
		"chunk-8c867314"
	],
	"./Profile/components/FeatureController.vue": [
		"32ca",
		"chunk-7cc33a86",
		"chunk-31822361"
	],
	"./Profile/components/Services.vue": [
		"2929",
		"chunk-7cc33a86",
		"chunk-bd99b69e"
	],
	"./Profile/index.vue": [
		"3853",
		"chunk-7cc33a86",
		"chunk-b973a296",
		"chunk-6628aa93"
	],
	"./ProjectSinglePage/index.vue": [
		"cd13",
		"chunk-3f11b7d4"
	],
	"./RandomOffers/index.vue": [
		"55e9",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-1d909750",
		"chunk-6e7b7d1c"
	],
	"./Reservation/index.vue": [
		"2702",
		"chunk-2b48674c"
	],
	"./ReserveNumber/index.vue": [
		"7b33",
		"chunk-4671d282"
	],
	"./Roaming/index.vue": [
		"39ee",
		"chunk-5d77da4b",
		"chunk-7b816018",
		"chunk-346d1308"
	],
	"./Roaming/internationalRoaming.vue": [
		"d025",
		"chunk-5d77da4b"
	],
	"./Roaming/roamingService.vue": [
		"f602",
		"chunk-7b816018",
		"chunk-512ed652"
	],
	"./SMSRoamingCountries/index.vue": [
		"1a12",
		"chunk-285cbea2"
	],
	"./SegmentDetails/index.vue": [
		"5d47",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-58ec44aa"
	],
	"./ServiceDetails/index.vue": [
		"0020",
		"chunk-0959019c"
	],
	"./SpecialServices/index.vue": [
		"69b7",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-423e2086"
	],
	"./Support/ContactUs.vue": [
		"6206",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-6aff967d"
	],
	"./Support/FAQs.vue": [
		"9f95",
		"chunk-73a65bac"
	],
	"./Support/Feedback.vue": [
		"d126",
		"chunk-dfa5129e"
	],
	"./Support/ServicesCenters.vue": [
		"93ed",
		"chunk-5d87ccbf",
		"chunk-5ac386e0"
	],
	"./Support/SupportContent.vue": [
		"87f6",
		"chunk-78164210"
	],
	"./Support/index.vue": [
		"9ac3",
		"chunk-5faa7b7d",
		"chunk-3231f082",
		"chunk-dfa5129e",
		"chunk-5d87ccbf",
		"chunk-22a58e27"
	],
	"./test/index.vue": [
		"feda",
		"chunk-1b50031c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;